export default __webpack_public_path__ + "static/media/team-sidebar-icon.22975cf7.svg";